export const CALLS_HISTORY_ERROR = 'Ocorreu um erro ao buscar seu histórico de ligações'